<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-05-20 14:30:34
 * @LastEditTime: 2020-11-20 11:28:18
-->
<template>
<!-- 面包屑导航栏 -->
    <div class="breadcrumb">
        <el-breadcrumb separator="/">
        <!-- 一级路由 -->
            <el-breadcrumb-item v-show="routerfname">{{$t(`lang.router.${routerfname}`)}}
            </el-breadcrumb-item>
            <!-- 二级路由 -->
            <el-breadcrumb-item v-show="routerchildren">{{$t(`lang.router.${routerchildren}`)}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                //面包屑导航二级name
                //获取当前路由name通过VueI18n切换中英文
                routerfname: this.$route.matched[0].name,
                //面包屑导航三级name
                //获取当前路由name通过VueI18n切换中英文 如果当前路由name为Index首页?等于'':等于当前路由名
                routerchildren:this.$route.matched[1].name=='Index'?'':this.$route.matched[1].name,
                routers: ''
            }
        },
        watch: {
            //监听路由
            '$route'(to) {
                if (to.matched.length === 2) {
                    if (to.matched[0].name) {
                        this.routerfname = to.matched[0].name
                    } else {
                        this.routerfname = ''
                    }
                    if (to.matched[1].name) {
                        this.routerchildren = to.matched[1].name
                    } else {
                        this.routerchildren = ''
                    }
                    if(to.matched[1].name=='Index'){
                        this.routerchildren = ''
                    }
                }
            }
        }
    }
</script>

<style scoped>
.breadcrumb{
    /* background-color: #f5f5f5; */
    line-height: 10vh;
    display: inline-block;
    margin-left: 20px;
    color: #ffffff;
}
</style>
